import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a0bf2888"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src", "alt"]
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Ensemble:", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Herstellung", -1))
const _hoisted_6 = { key: 1 }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "KünstlerIn:", -1))
const _hoisted_8 = /*#__PURE__*/_createTextVNode()
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { key: 2 }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Entstehungsort/-gebiet:", -1))
const _hoisted_13 = { key: 3 }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Datierung:", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Bildträger", -1))
const _hoisted_16 = { key: 4 }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Material:", -1))
const _hoisted_18 = { key: 5 }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Technik:", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Lokalisierung", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Staat:"),
  /*#__PURE__*/_createTextVNode(" Österreich")
], -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Bundesland:"),
  /*#__PURE__*/_createTextVNode(" Niederösterreich")
], -1))
const _hoisted_23 = { key: 6 }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Standort:", -1))
const _hoisted_25 = { key: 7 }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Institution:", -1))
const _hoisted_27 = { key: 8 }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Allgemeines", -1))
const _hoisted_29 = { key: 9 }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Archivnummer:", -1))
const _hoisted_31 = /*#__PURE__*/_createTextVNode()
const _hoisted_32 = ["href"]
const _hoisted_33 = { key: 10 }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Inventarnummer:", -1))
const _hoisted_35 = {
  key: 0,
  class: "folio"
}
const _hoisted_36 = { key: 11 }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Fotonummer:", -1))
const _hoisted_38 = { class: "objects-container" }
const _hoisted_39 = { class: "objects" }
const _hoisted_40 = { key: 0 }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Auf diesem Bild sind folgende Objekte zu sehen. Wählen Sie, um zu taggen!", -1))
const _hoisted_42 = { key: 1 }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, null, -1))
const _hoisted_44 = { class: "call2action" }
const _hoisted_45 = ["onClick"]
const _hoisted_46 = { key: 0 }
const _hoisted_47 = { key: 1 }
const _hoisted_48 = /*#__PURE__*/_createTextVNode("Hier sind die Standorte von Kunstwerken in der thingTAG-App.")
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_50 = /*#__PURE__*/_createTextVNode("Klicke einen an und erfahre, welche Dinge sich auf den Bildern vor Ort befinden.")
const _hoisted_51 = [
  _hoisted_48,
  _hoisted_49,
  _hoisted_50
]
const _hoisted_52 = ["onClick"]
const _hoisted_53 = { class: "img-container" }
const _hoisted_54 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_header = _resolveComponent("page-header")!
  const _component_item_list_loader = _resolveComponent("item-list-loader")!
  const _component_card_list_loader = _resolveComponent("card-list-loader")!
  const _component_work_page_loader = _resolveComponent("work-page-loader")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_chip = _resolveComponent("ion-chip")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_card_title = _resolveComponent("ion-card-title")!
  const _component_ion_card_header = _resolveComponent("ion-card-header")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_side_menu = _resolveComponent("side-menu")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_page_header, {
        canGoBack: false,
        title: _ctx.$t('message.localinfo')
      }, null, 8, ["title"]),
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withCtx(() => [
          (!_ctx.isReady)
            ? (_openBlock(), _createBlock(_component_ion_grid, { key: 0 }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_row, { class: "ion-justify-content-center" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_col, {
                        "size-xs": "12",
                        "size-sm": "12",
                        "size-md": "12",
                        "size-lg": "6"
                      }, {
                        default: _withCtx(() => [
                          (_ctx.step === 1 || _ctx.step === 2)
                            ? (_openBlock(), _createBlock(_component_item_list_loader, { key: 0 }))
                            : _createCommentVNode("", true),
                          (_ctx.step === 3)
                            ? (_openBlock(), _createBlock(_component_card_list_loader, {
                                key: 1,
                                cards: [1, 2, 3, 4 ,5 , 6]
                              }))
                            : _createCommentVNode("", true),
                          (_ctx.step === 4)
                            ? (_openBlock(), _createBlock(_component_work_page_loader, { key: 2 }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : (_openBlock(), _createBlock(_component_ion_grid, {
                key: 1,
                class: "ion-padding"
              }, {
                default: _withCtx(() => [
                  (_ctx.step === 4)
                    ? (_openBlock(), _createBlock(_component_ion_row, {
                        key: 0,
                        class: "ion-justify-content-center step4"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_col, {
                            "size-xs": "12",
                            "size-sm": "12",
                            "size-md": "12",
                            "size-lg": "6"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("img", {
                                class: "main-image",
                                src: 'https://realonline.imareal.sbg.ac.at/imageservice/kupo/' + _ctx.work.dia_nr,
                                alt: _ctx.work.title
                              }, null, 8, _hoisted_1),
                              _createElementVNode("h3", null, [
                                _createElementVNode("strong", null, _toDisplayString(_ctx.work.bildthema), 1),
                                (_ctx.work.bildthema_comment)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_2, " (" + _toDisplayString(_ctx.work.bildthema_comment) + ")", 1))
                                  : _createCommentVNode("", true)
                              ]),
                              (_ctx.work.ensemble)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_3, [
                                    _hoisted_4,
                                    _createTextVNode(" " + _toDisplayString(_ctx.work.ensemble), 1)
                                  ]))
                                : _createCommentVNode("", true),
                              _hoisted_5,
                              (_ctx.work.kuenstler)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_6, [
                                    _hoisted_7,
                                    _hoisted_8,
                                    (_ctx.work.kuenstler)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.work.kuenstler), 1))
                                      : (_openBlock(), _createElementBlock("span", _hoisted_10, "Künstler nicht bekannt"))
                                  ]))
                                : _createCommentVNode("", true),
                              (_ctx.work.entstehungsort)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_11, [
                                    _hoisted_12,
                                    _createTextVNode(" " + _toDisplayString(_ctx.work.entstehungsort), 1)
                                  ]))
                                : _createCommentVNode("", true),
                              (_ctx.work.datierung)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_13, [
                                    _hoisted_14,
                                    _createTextVNode(" " + _toDisplayString(_ctx.work.datierung), 1)
                                  ]))
                                : _createCommentVNode("", true),
                              _hoisted_15,
                              (_ctx.work.material)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_16, [
                                    _hoisted_17,
                                    _createTextVNode(" " + _toDisplayString(_ctx.work.material), 1)
                                  ]))
                                : _createCommentVNode("", true),
                              (_ctx.work.technik)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_18, [
                                    _hoisted_19,
                                    _createTextVNode(" " + _toDisplayString(_ctx.work.technik), 1)
                                  ]))
                                : _createCommentVNode("", true),
                              _hoisted_20,
                              _hoisted_21,
                              _hoisted_22,
                              (_ctx.work.standort)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_23, [
                                    _hoisted_24,
                                    _createTextVNode(" " + _toDisplayString(_ctx.work.standort), 1)
                                  ]))
                                : _createCommentVNode("", true),
                              (_ctx.work.institution)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_25, [
                                    _hoisted_26,
                                    _createTextVNode(" " + _toDisplayString(_ctx.work.institution), 1)
                                  ]))
                                : _createCommentVNode("", true),
                              (_ctx.work.standort_zusatz)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_27, _toDisplayString(_ctx.work.standort_zusatz), 1))
                                : _createCommentVNode("", true),
                              _hoisted_28,
                              (_ctx.work.archiv_nr)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_29, [
                                    _hoisted_30,
                                    _hoisted_31,
                                    _createElementVNode("a", {
                                      href: 'https://realonline.imareal.sbg.ac.at/detail/nr-' + _ctx.work.archiv_nr,
                                      target: "_blank"
                                    }, _toDisplayString(_ctx.work.archiv_nr), 9, _hoisted_32)
                                  ]))
                                : _createCommentVNode("", true),
                              (_ctx.work.inventar_nr)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_33, [
                                    _hoisted_34,
                                    _createTextVNode(" " + _toDisplayString(_ctx.work.inventar_nr), 1),
                                    (_ctx.work.fol)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_35, "(Folio " + _toDisplayString(_ctx.work.fol) + ")", 1))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true),
                              (_ctx.work.dia_nr)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_36, [
                                    _hoisted_37,
                                    _createTextVNode(" " + _toDisplayString(_ctx.work.dia_nr), 1)
                                  ]))
                                : _createCommentVNode("", true),
                              _createElementVNode("div", _hoisted_38, [
                                _createElementVNode("div", _hoisted_39, [
                                  (_ctx.work.work_objects.length)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                                        _hoisted_41,
                                        _createElementVNode("p", null, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.work.work_objects, (workobject) => {
                                            return (_openBlock(), _createBlock(_component_ion_chip, {
                                              key: workobject,
                                              class: _normalizeClass({selected: _ctx.selectedObjectId === workobject.id}),
                                              onClick: () => {
                          _ctx.selectedObjectId = workobject.id
                          _ctx.selectedObjectTitle = workobject.title
                        }
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_ion_label, null, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(workobject.title), 1)
                                                  ]),
                                                  _: 2
                                                }, 1024)
                                              ]),
                                              _: 2
                                            }, 1032, ["class", "onClick"]))
                                          }), 128))
                                        ]),
                                        _createVNode(_component_ion_button, {
                                          disabled: !_ctx.selectedObjectId,
                                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.router.push('/tagging/'+_ctx.selectedObjectId+'/'+_ctx.work.id)))
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.selectedObjectTitle ? _ctx.selectedObjectTitle + _ctx.taggingButtonLabel : _ctx.$t('message.taggingImage')), 1)
                                          ]),
                                          _: 1
                                        }, 8, ["disabled"])
                                      ]))
                                    : (_openBlock(), _createElementBlock("p", _hoisted_42, " Keine Objekte auf diesem Bild "))
                                ])
                              ]),
                              _hoisted_43
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : (_ctx.step === 2)
                      ? (_openBlock(), _createBlock(_component_ion_row, {
                          key: 1,
                          class: "ion-justify-content-center step2"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_col, {
                              "size-xs": "12",
                              "size-sm": "12",
                              "size-md": "12",
                              "size-lg": "6"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("h3", null, _toDisplayString(_ctx.currentlocation), 1),
                                _createElementVNode("div", _hoisted_44, _toDisplayString(_ctx.$t("message.chooseinstitution")), 1),
                                _createElementVNode("ul", null, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.institutions.institutions, (institution) => {
                                    return (_openBlock(), _createElementBlock("li", {
                                      key: institution,
                                      onClick: 
                  () => {
                    _ctx.router.push(
                      '/localinfo/' + _ctx.currentlocation + '/' + institution
                    );
                  }
                
                                    }, _toDisplayString(institution), 9, _hoisted_45))
                                  }), 128))
                                ])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : (_ctx.step === 1)
                        ? (_openBlock(), _createBlock(_component_ion_row, {
                            key: 2,
                            class: "ion-justify-content-center step1"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_col, {
                                "size-xs": "12",
                                "size-sm": "12",
                                "size-md": "12",
                                "size-lg": "6"
                              }, {
                                default: _withCtx(() => [
                                  (_ctx.locations.length > 0)
                                    ? (_openBlock(), _createElementBlock("h3", _hoisted_46, "Planst Du einen Ausflug in Niederösterreich?"))
                                    : _createCommentVNode("", true),
                                  (_ctx.locations.length > 0)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_47, _hoisted_51))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("ul", null, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.locations, (mylocation) => {
                                      return (_openBlock(), _createElementBlock("li", {
                                        lines: "none",
                                        button: "",
                                        key: mylocation,
                                        onClick: 
                  () => {
                    _ctx.router.push('/localinfo/' + mylocation?.name);
                  }
                
                                      }, [
                                        _createVNode(_component_ion_label, null, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(mylocation?.name), 1)
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ], 8, _hoisted_52))
                                    }), 128))
                                  ])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : (_ctx.step === 3)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                              _createVNode(_component_ion_row, { class: "ion-justify-content-center" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_col, {
                                    class: "short",
                                    "size-xs": "12",
                                    "size-sm": "12",
                                    "size-md": "12",
                                    "size-lg": "6"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("h3", null, _toDisplayString(_ctx.institution.name + " " + _ctx.institution.location), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_row, { class: "ion-justify-content-center step3" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_col, {
                                    "size-xs": "12",
                                    "size-sm": "12",
                                    "size-md": "12",
                                    "size-lg": "6"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_row, null, {
                                        default: _withCtx(() => [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.institution.works, (work, index) => {
                                            return (_openBlock(), _createBlock(_component_ion_col, {
                                              class: "ion-justify-content-center",
                                              "size-xs": "12",
                                              "size-sm": "6",
                                              "size-md": "6",
                                              "size-lg": "4",
                                              key: index
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_ion_card, {
                                                  class: "ion-no-margin",
                                                  button: "",
                                                  onClick: 
                      () =>
                        _ctx.router.push(
                          '/localinfo/' +
                            work.standort +
                            '/' +
                            work.institution +
                            '/' +
                            work.id
                        )
                    
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createElementVNode("div", _hoisted_53, [
                                                      _createElementVNode("img", {
                                                        class: _normalizeClass('card-image-' + index),
                                                        src: _ctx.loadImage(work.dia_nr, 'card-image-' + index),
                                                        alt: "",
                                                        loading: "lazy"
                                                      }, null, 10, _hoisted_54)
                                                    ]),
                                                    _createVNode(_component_ion_card_header, null, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_ion_card_title, null, {
                                                          default: _withCtx(() => [
                                                            _createTextVNode(_toDisplayString(work.bildthema), 1)
                                                          ]),
                                                          _: 2
                                                        }, 1024)
                                                      ]),
                                                      _: 2
                                                    }, 1024)
                                                  ]),
                                                  _: 2
                                                }, 1032, ["onClick"])
                                              ]),
                                              _: 2
                                            }, 1024))
                                          }), 128))
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ], 64))
                          : _createCommentVNode("", true)
                ]),
                _: 1
              }))
        ]),
        _: 1
      }),
      _createVNode(_component_side_menu, { showGoBack: true })
    ]),
    _: 1
  }))
}